// SPDX-License-Identifier: MIT
// Desktop-local provider config (Point A, decision D3). On desktop the chosen
// AI provider lives in a JSON file in the app config dir (read/written by the
// Rust get_provider_config / set_provider_config commands) — NOT in Supabase, so
// the desktop app works offline and the sovereign endpoint call leaves the user's
// own machine. Web keeps storing in public.user_ai_providers (Supabase).
import type { AiProviderKind } from '../auth/provider-config';
import { tauriInvoke } from './tauri';

export interface StoredProviderConfig {
  kind: AiProviderKind;
  // Present only for the 'sovereign' kind.
  endpoint_url?: string | null;
  model?: string | null;
  api_key?: string | null;
}

// Reads the desktop-local provider config, or null when none is set yet
// (newbie state). Tolerant: a missing/empty/malformed store reads as "unset"
// so the bridge falls back to the default `claude -p` path.
export async function readDesktopProviderConfig(): Promise<StoredProviderConfig | null> {
  const raw = await tauriInvoke()('get_provider_config');
  if (typeof raw !== 'string' || raw.length === 0) return null;
  try {
    const obj = JSON.parse(raw) as StoredProviderConfig;
    return obj && typeof obj.kind === 'string' ? obj : null;
  } catch {
    return null;
  }
}

export async function writeDesktopProviderConfig(cfg: StoredProviderConfig): Promise<void> {
  await tauriInvoke()('set_provider_config', { json: JSON.stringify(cfg) });
}
